import { render, staticRenderFns } from "./component.vue?vue&type=template&id=5932ebca&scoped=true"
import script from "./component.vue?vue&type=script&lang=js"
export * from "./component.vue?vue&type=script&lang=js"
import style0 from "./component.vue?vue&type=style&index=0&id=5932ebca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5932ebca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5932ebca')) {
      api.createRecord('5932ebca', component.options)
    } else {
      api.reload('5932ebca', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=5932ebca&scoped=true", function () {
      api.rerender('5932ebca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ResizeContainer/component.vue"
export default component.exports